import React from 'react';
// TODO: use useId instead when upgraded to React 18
import { nanoid } from 'nanoid';
import { Tooltip } from '@trevor/ui-components';

export type ElementWithToolTipProps = {
  text: string;
};

export const ElementWithToolTip: React.FC<ElementWithToolTipProps> = ({
  text,
  children,
}) => {
  const id = nanoid();
  return (
    <>
      <div data-tooltip-id={id}>{children}</div>
      <Tooltip id={id} place="top">
        {text}
      </Tooltip>
    </>
  );
};

export default ElementWithToolTip;
